import React from "react";
import { FeaturedProject, CompactProject } from "../components/ProjectItem";
import { ProjectList } from "../helpers/ProjectList";

const visible = ProjectList.filter((project) => !project.hidden);
const featured = visible.filter((project) => project.card?.featured);
const earlier = visible.filter((project) => !project.card?.featured);

function Projects() {
  return (
    <div className="w-full pb-20 text-[#111] dark:text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <header className="pt-10 pb-8 lg:pt-14 lg:pb-10 max-w-3xl">
          <h1 className="text-[40px] sm:text-5xl font-bold leading-tight">Projects</h1>
          <p className="pt-3 text-lg sm:text-xl leading-relaxed text-[#444] dark:text-[#d6d9e3]">
            Apps and a game I've designed, built and shipped on my own time, from on-device AI search
            to a Unity game you can play right here.
          </p>
        </header>

        <div className="flex flex-col gap-8 lg:gap-10">
          {featured.map((project, i) => (
            <FeaturedProject key={project.id} project={project} reverse={i % 2 === 1} />
          ))}
        </div>

        {earlier.length > 0 && (
          <section aria-labelledby="earlier-heading" className="pt-16 lg:pt-20">
            <h2 id="earlier-heading" className="text-[28px] sm:text-[32px] font-bold leading-tight">
              Earlier work
            </h2>
            <p className="pt-2 pb-6 text-lg text-[#444] dark:text-[#d6d9e3]">
              From my time at Wentworth Institute of Technology.
            </p>
            <div className="grid gap-6 md:grid-cols-2">
              {earlier.map((project) => (
                <CompactProject key={project.id} project={project} />
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default Projects;
